<script lang="ts" setup>
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import CounterQC from '@qicgroupdoha/qic-connect-ds/components/CounterQC'

  interface Props {
    title?: string
    description?: string
    maxValue?: number
    minValue?: number
    dataTest?: string
  }

  withDefaults(defineProps<Props>(), {
    title: undefined,
    description: undefined,
    maxValue: 20,
    minValue: 0,
    dataTest: 'amount-counter',
  })

  const modelValue = defineModel<number>('modelValue', { default: 0 })
</script>

<template>
  <WrapperQC class="amount-counter-qc" gap="var(--spacing-3)" :data-test="dataTest">
    <WrapperQC v-if="title || description" direction="column" gap="var(--spacing-2)">
      <p v-if="title" class="amount-counter-qc__title text-medium">{{ title }}</p>
      <span v-if="description" class="amount-counter-qc__desc text-small-medium">{{
        description
      }}</span>
    </WrapperQC>
    <CounterQC v-model="modelValue" :max="maxValue" :min="minValue" :data-test="dataTest" />
  </WrapperQC>
</template>

<style scoped lang="scss">
  .amount-counter-qc {
    justify-content: space-between;
    align-items: center;
  }

  .amount-counter-qc__desc {
    color: var(--colorTxtSrfSecondary);
  }
</style>
